import { useMemo } from 'react';
import { MenuItem } from '@mui/material';

import { Select, SelectProps } from './Select';

export type TimePickerProps = {
  step?: number;
  value: number;
  onFormat: (seconds: number) => string;
  onChange: (seconds: number) => void;
} & Omit<SelectProps, 'value' | 'onChange'>;

const DAY_HOURS = 24;
const HOUR_MINUTES = 60;
const MINUTE_SECONDS = 60;
const DAY_SECONDS = DAY_HOURS * HOUR_MINUTES * MINUTE_SECONDS;
// 30 minutes
const DEFAULT_STEP = 30 * MINUTE_SECONDS;

export function TimePicker({
  onFormat,
  onChange,
  value,
  step = DEFAULT_STEP,
  ...props
}: TimePickerProps) {
  const options: number[] = useMemo(() => {
    const stepCount = Math.floor(DAY_SECONDS / step);

    const result: number[] = [];
    for (let i = 0; i < stepCount; i++) {
      result.push(i * step);
    }

    return result;
  }, [step]);

  return (
    <Select
      {...props}
      value={value}
      renderValue={value => onFormat(value as number)}
      onChange={event => onChange(Number(event.target.value))}
    >
      {options.map(seconds => (
        <MenuItem key={seconds} value={seconds}>
          {onFormat(seconds)}
        </MenuItem>
      ))}
    </Select>
  );
}
